import { AudioChunk } from '../../state/entities/AudioChunk'
import { PositionRange } from '../../types'
import { AudioBufferChunk } from '../../state/entities/AudioBufferChunk'
import { isAudioBufferChunk } from './isAudioBufferChunk'

export function isAudioChunkToPlay(chunk: AudioChunk, [start, end]: PositionRange): chunk is AudioBufferChunk {
  return isAudioBufferChunk(chunk) && chunk.start < end && chunk.end > start
}
